export enum EBrandMenuItem {
	LOGOTYPE = 'logotype',
	PALETTE = 'palette',
	FONTS = 'fonts',
	BLOCK = 'block',
	BADGE = 'badge',
	APP_ICON = 'appIcon',
	ILLUSTRATIONS = 'illustrations',
}

export enum EBrandScreen {
	LOGOTYPE = 'logotype',
	LOGOGRAM = 'logogram',
	PALETTE = 'palette',
	FONTS = 'fonts',
	BLOCK = 'block',
	BADGE = 'badge',
	APP_ICON = 'appIcon',
	ILLUSTRATIONS = 'illustrations',
	GRADIENTS = 'gradients',
	PATTERNS = 'patterns',
}

export enum EBrandFileName {
	ALL = 'BOOM-visual-style',
	LOGOTYPE_COLOR = 'BOOM-logotype-color',
	LOGOTYPE_GRAYSCALE = 'BOOM-logotype-grayscale',
	LOGOGRAM_COLOR = 'BOOM-logogram-color',
	LOGOGRAM_GRAYSCALE = 'BOOM-logogram-grayscale',
	FONTS = 'BOOM-fonts',
	BLOCK_MAIN = 'BOOM-block-dark',
	BLOCK_ALTERNATIVE = 'BOOM-block-light',
	BADGE_MAIN = 'BOOM-badge-light',
	BADGE_DARK = 'BOOM-badge-dark',
	APP_ICON_LIGHT = 'BOOM-app-icon-light',
	APP_ICON_DARK = 'BOOM-app-icon-dark',
	ILLUSTRATIONS = 'BOOM-illustrations',
	GRADIENTS = 'BOOM-gradients',
	PATTERNS = 'BOOM-patterns',
}

export enum EBrandImage {
	BRAND_MAN = 'brand-man',
	BLOCK_MAIN = 'block-main',
	BLOCK_ALTERNATIVE = 'block-alternative',
	BADGE_LIGHT = 'badge-light',
	BADGE_DARK = 'badge-dark',
	APP_ICON_LIGHT = 'app-icon-light',
	APP_ICON_DARK = 'app-icon-dark',
	GRADIENT_01 = 'gradient-01',
	GRADIENT_02 = 'gradient-02',
	GRADIENT_03 = 'gradient-03',
	GRADIENT_04 = 'gradient-04',
	GRADIENT_05 = 'gradient-05',
	GRADIENT_06 = 'gradient-06',
	ILLUSTRATION_BOOM = 'illustration-boom',
	ILLUSTRATION_DANCE = 'illustration-dance',
	ILLUSTRATION_DOGMAN = 'illustration-dogman',
	ILLUSTRATION_SAD = 'illustration-sad',
	ILLUSTRATION_SEARCH = 'illustration-search',
	PATTERN_01 = 'pattern-01',
	PATTERN_02 = 'pattern-02',
	PATTERN_03 = 'pattern-03',
	PATTERN_04 = 'pattern-04',
	PATTERN_05 = 'pattern-05',
	PATTERN_06 = 'pattern-06',
	PATTERN_07 = 'pattern-07',
	PATTERN_08 = 'pattern-08',
	PATTERN_09 = 'pattern-09',
	PATTERN_10 = 'pattern-10',
	PATTERN_11 = 'pattern-11',
	PATTERN_12 = 'pattern-12',
	PATTERN_13 = 'pattern-13',
	PATTERN_14 = 'pattern-14',
	PATTERN_15 = 'pattern-15',
	PATTERN_16 = 'pattern-16',
	PATTERN_17 = 'pattern-17',
	PATTERN_18 = 'pattern-18',
}